<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      ><template slot-scope="{ row, index }" slot="filesPathArr">
        <viewer v-if="row.filesPathArr">
          <img
            v-for="(x, index) in row.filesPathArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="1000"
      ref="formModel"
    >
      <Input
        v-model="item.ono"
        placeholder="请选择"
        slot="ono"
        @on-focus="openForm = true"
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Modal
      v-model="openForm"
      title="订单号"
      footer-hide
      fullscreen
      width="1000"
    >
      <dingdanhao
        :scan="true"
        @obj="
          item.ono = $event.no;
          openForm = false;
        "
        :find="{ cid: item.cid }"
        v-if="openForm"
      ></dingdanhao>
    </Modal>
  </div>
</template>
<script>
var kehuitems = [];
import dingdanhao from "../fahuo/xitongkaidan.vue";
export default {
  components: { dingdanhao },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "",
        ticketNo: "",
        cid: "",
        customer: "",
        creditCode: "",
        companynameTicket: "",
        addressTicket: "",
        bank: "",
        telTicket: "",
        account: "",
        currency: "人民币",
        totalPrice: 0,
        type: 0,
        tel: "",
        remark: "",
        filesPath: "",
        filesPathArr: [],
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      forms: [
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          val: "",
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
        },

        {
          title: "订单号",
          key: "ono",
          required: "true",
          val: "",
          slotForm: "ono",
        },
        {
          title: "发票编号",
          key: "ticketNo",
          required: true,
          type: "Input",
        },
        {
          title: "统一信用代码",
          key: "creditCode",
          required: false,
          val: "",
          type: "Input",
        },

        {
          title: "开票公司名称",
          key: "companynameTicket",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "开票地址",
          key: "addressTicket",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "开票银行",
          key: "bank",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "开票金额",
          key: "totalPrice",
          required: "true",
          val: 0,
          type: "InputNumber",
        },
        {
          title: "币别",
          key: "currency",
          required: "true",
          val: "",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
        },
        {
          title: "类型",
          key: "type",
          key2: "type2",
          required: "true",
          val: "",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["payType"],
        },
        {
          title: "凭据",
          key: "filesPathArr",
          slot: "filesPathArr",
          required: false,
          val: "",
          type: "lyPhoto",
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    reach(v) {
      this.item.ono = v.ono;
      this.item.cid = v.cid;
      this.openAdd();
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/ticket/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].type2 = this.lydic.getVal("payType", data[i].type);
          data[i].filesPathArr = this.utils.isEmpty(data[i].filesPath)
            ? []
            : JSON.parse(data[i].filesPath);
        }
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      this.item.customer = aaa.name;
      this.item.filesPath = JSON.stringify(this.item.filesPathArr);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/ticket/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-fms/ticket/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-fms/ticket/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data:{},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
            ticket: this.utils.isEmpty(data[i].ticket)
              ? {
                  telTicket: "",
                  bank: "",
                  companynameTicket: "",
                  addressTicket: "",
                }
              : JSON.parse(data[i].ticket),
          };
          kehuitems.push(obj);
        }
        console.log(kehuitems);
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
    //
  },
  computed: {
    ticket() {
      return this.item.cid;
    },
  },
  watch: {
    ticket(v) {
      for (let i = 0; i < kehuitems.length; i++) {
        if (v == kehuitems[i].id) {
          var m = kehuitems[i].ticket;
          this.item.addressTicket = m.addressTicket;
          this.item.bank = m.bank;
          this.item.companynameTicket = m.companynameTicket;
          this.item.telTicket = m.telTicket;
        }
      }
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/kaipiaoguanli.vue